import React from 'react';
import sharedStyle from '../layout.module.scss';
import style from './layout-c.module.scss';
import classNames from 'classnames';

type LayoutCProps = {
    mainContent: React.ReactNode;
    heroContent?: React.ReactNode;
    headerContent?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    narrow?: boolean;
    extraNarrow?: boolean;
    noMargin?: boolean;
};

export const LayoutC = ({
    mainContent,
    children,
    headerContent,
    heroContent,
    className,
    narrow,
    extraNarrow,
    noMargin
}: LayoutCProps) => {
    const layoutInnerClass = extraNarrow
        ? style.extraNarrowLayoutInner
        : sharedStyle.layoutInner;

    return (
        <>
            {heroContent}
            {headerContent && (
                <div className="site-width layout">{headerContent}</div>
            )}
            <div
                className={classNames(
                    'site-width layout',
                    narrow && style.narrow,
                    extraNarrow && style.extraNarrow
                )}>
                <div
                    className={classNames(
                        !noMargin && layoutInnerClass,
                        className
                    )}>
                    {children}
                    <main className={sharedStyle.main}>{mainContent}</main>
                </div>
            </div>
        </>
    );
};
